import React from 'react';
import {connect} from 'react-redux';
import List from './List';
import actions from './actions';
import AdminBaseLayoutContainer from "../../components/BaseLayout/AdminBaseLayoutContainer";


const mapStateToProps = state => {
  return {
    ...state.rules,
  };
};

const mapDispatchToProps = actions;

class ListContainer extends React.Component {

  componentDidMount() {
    this.props.onInit()
  }

  render() {
    return (
      <AdminBaseLayoutContainer>
        <List {...this.props}/>
      </AdminBaseLayoutContainer>
    )
  }

}


export default connect(mapStateToProps, mapDispatchToProps)(ListContainer);
